<template>
  <div class="complain-container">
    <HeaderO title="投诉详情"></HeaderO>
    <div class="main-containe">
      <div class="title">产品信息</div>
      <van-cell-group>
        <van-field
          v-model="Datadetail.complaintTitle"
          readonly
          label="标题"
        />
        <van-field
          v-model="statusName"
          readonly
          label="状态"
        />
         <van-field
          v-model="Datadetail.orgName"
          readonly
          label="销售公司"
        />
         <van-field
          v-model="complaintType"
          readonly
          label="投诉类型"
        />
         <van-field
          v-model="Datadetail.orderCode"
          readonly
          label="订单编号"
        />
         <van-field
          v-model="Datadetail.deliveryOrderCode"
          readonly
          label="发货单编号"
        />
        
        <van-field
          v-model="Datadetail.complaintTime"
          readonly
          label="购货日期"
        />

        <van-field
          v-model="Datadetail.complaintExtraModel.productor"
          readonly
          label="生产企业"
        /> 
        <van-field
          v-model="Datadetail.complaintExtraModel.productName"
          readonly
          label="产品名称"
        />

        <van-field
          v-model="Datadetail.complaintExtraModel.materialCode"
          readonly
          label="物料编码"
        />
        <van-field
          v-model="Datadetail.complaintExtraModel.productMark"
          readonly
          label="产品牌号"
        />

        <van-field
          v-model="Datadetail.complaintExtraModel.productLevel"
          readonly
          label="产品等级"
        />
        <van-field
          v-model="Datadetail.complaintExtraModel.productBatch"
          readonly
          label="产品批次号"
        /> 
        <van-field
          v-model="Datadetail.complaintExtraModel.unitPrice"
          readonly
          label="购货单价"
        />
        <van-field
          v-model="Datadetail.complaintExtraModel.purchaseQuantity"
          readonly
          label="购货量（吨）"
        />
        <van-field
          v-model="Datadetail.useAmount"
          readonly
          label="已用量（吨）"
        />
        <van-field
          v-model="Datadetail.claimAmount"
          readonly
          label="索赔金额"
        />
        <van-field
          readonly
          v-model="Datadetail.damageAmount"
          label="受损量"
        />
      </van-cell-group>
      <div class="title">问题描述</div>
      <van-field
        v-model="Datadetail.complaintDesc"
        rows="5"
        readonly
        type="textarea"
      />
      <div class="title">申请信息</div>
      <van-cell-group>
        <van-field
          v-model="Datadetail.companyName"
          readonly
          label="公司名称"
        />
        <van-field
          v-model="Datadetail.contactorName"
          readonly
          label="联系人"
        />
        <van-field
          v-model="Datadetail.contactorMobile"
          readonly
          label="电话"
          placeholder="请输入电话"
        />
        <van-field
          v-model="Datadetail.contactorEmail"
          readonly
          label="邮箱"
        />
      </van-cell-group>
      <div class="title">附件</div>
      <div class="file">
        <a href="form.complaintPicUrl">查看附件</a>
        <a style="margin-left:20px;" :href="Typetsyj('06')[0].picUrl">查看结案单</a>
      </div>
      <div class="title">处理详情</div>
      <div class="bgfff">
        <p>初步响应时间：<span>{{Typetsyj('03')[0].createTime==1610007319000?'': new Date(Typetsyj('03')[0].createTime).toLocaleString('chinese',{hour12:false}) }}</span></p>
        <p>初步响应意见：</p>
        <van-field
          :value="Typetsyj('03')[0].remark || ''"
          rows="5"
          readonly
          type="textarea"
        />
      </div>
      <div v-if="$route.query.status!='06'" class="bgfff">
        <p>最终解决时间：{{Typetsyj('06')==[]?'':Typetsyj('06')[0].createTime==1610007319000?'': new Date(Typetsyj('06')[0].createTime).toLocaleString('chinese',{hour12:false}) }}</p>
        <p>最终处理意见：</p>
        <van-field
          :value="Typetsyj('06')==[]?'':Typetsyj('06')[0].remark"
          rows="5"
          readonly
          type="textarea"
        />
      </div>
      <div v-if="$route.query.status=='06'">

      </div>
      <div class="ldr-header" v-show="flag">
          <div class="header-type">结案处理</div>
      </div>

    </div>
    <!-- <div v-if="!editFlag" class="btn-order">
      <div class="card-btn">
        <van-button
          class="btn"
          @click="editBtn"
        >编 辑</van-button>
      </div>
    </div>
    <div v-if="editFlag" class="btn-order">
      <div class="card-btn">
        <van-button
          class="btn"
          @click="submitBtn"
        >提 交</van-button>
      </div>
    </div> -->

  </div>

</template>
<script>
import HeaderO from "@/components/HeaderO.vue";
import transactionApi from "@/request/transactionApi";
export default {
  name: "ComplaintList",
  components: {
    HeaderO,
  },
  data() {
    return {
      form: {
        complaintTitle: "", //标题
        complaintType: "", //投诉类型
        orderCode: "", //订单编号
        orderNo: "",
        purchaseTime: "",
        unitPrice: "", //成交单价
        purchaseQuantity: "",
        deliveryOrderCode: "", //交货单编号
        deliveryQuantity: "",
        productName: "", //产品名称
        materialCode: "",
        productBatch: "",
        productMark: "",
        productLevel: "",
        claimAmount: "", //索赔金额
        useAmount: "", //已用量
        damageAmount: "", //受损量
        complaintDesc: "", //问题描述
        orgName: "", //公司名称
        contactorName: "", //联系人
        contactorMobile: "", //联系电话
        contactorEmail: "", //联系邮箱
        orgCode: "1", //销售公司
        complaintStatus: "01", //投诉状态
        quantity: "",
        licenseUrls: "",
        salesCompany: "",
        complaintTime: "", //投诉申请时间
        huifuContent: "*** 24小时内答复*** ",
        zuizhong: "*** 处理完毕*** ",
      },
      Datadetail: {},
      complaintStatus: "",
      unitList: [
        { value: "抚顺石化" },
        { value: "吉林石化" },
        { value: "兰州石化" },
      ],
      unitLists: [{ value: "低密度聚乙烯PE" }],
      flag: false,
      flags: false,
      editFlag: false,
      buyersetName: "", //买家结案文件名
      buyersetUrl: "", //买家结案地址
    };
  },
  computed: {
    complaintType() {
        let complaintType ="";
        switch (this.Datadetail.complaintType) {
          case "01":
            complaintType = "产品质量投诉";
            break;
          case "02":
            complaintType = "产品计量投诉";
            break;
          case "03":
            complaintType = "运输批次投诉";
            break;
          case "04":
            complaintType = "包装破损投诉";
            break;
          case "05":
            complaintType = "退货申请";
            break;
          case "06":
            complaintType = "其他投诉";
            break;
        }
        return complaintType;
    }, 
    
    statusName() {
      let statusName ="";
        switch (this.Datadetail.complaintStatus) {
          case "01":
            statusName = "已保存";
            break;
          case "02":
            statusName = "待处理";
            break;
          case "03":
            statusName = "已答复";
            break;
          case "04":
            statusName = "处理中";
            break;
          case "05":
            statusName = "已处理";
            break;
          case "06":
            statusName = "待审核";
            break;

          case "07":
            statusName = "已撤销";
            break;
          case "08":
            statusName = "审核拒绝";
            break;
          case "09":
            statusName = "已解决";
            break;
          case "10":
            statusName = "已结案";
            break;
        }
        return statusName;
    }
  },
  mounted() {
    // this.getlist();
    this.complaintStatus = this.$route.query.status;
    this.getList();
  },
  methods: {
    // editBtn() {
    //   this.editFlag = true;
    //   this.getlist();
    // },
    tjAnDown() {
      // 提交结案
      transactionApi.closureComplaint({
        fileUrl: this.buyersetUrl,
        fileName: this.buyersetName,
        companyComplaintId: this.$route.query.companyComplaintId,
        channel: "02",
      }).then(res=> {
        if (res.returnCode == "0") {
          this.$toast.success("提交成功");
        } else {
          this.$toast({
            type: "fail",
            message: res.returnMessage,
            duration: 1500,
          });
        }
      });    
    },
    // async jieAnDown() {
    //   // 结案单下载
    //   let obj = await this.Typetsyj("06")[0];
    //   this.$utils.downloadFile(
    //     `${this.$common.interfacePath.serverTestUrl}/basicdata/downloadFile`,
    //     "post",
    //     {
    //       fileKey: `${obj.picUrl}`,
    //       fileName: `${obj.picName}`,
    //     }
    //   );
    // },
    getList() {
      let companyComplaintId = this.$route.query.companyComplaintId;
      transactionApi.getdetail({ companyComplaintId }).then((res) => {
        if (res.returnCode == "0") {
          // result=this.ry_timeFilter(result.complaintTime)
          let obj = {
            category: "06",
            companyComplaintId: 366,
            companyComplaintLogId: 415,
            createTime: 1610007319000,
            createUserId: 95,
            createUserName: "华北管理员",
            picName: "",
            picUrl: "",
            remark: "",
          };
          let obj2 = {
            category: "03",
            companyComplaintId: 366,
            companyComplaintLogId: 415,
            createTime: 1610007319000,
            createUserId: 95,
            createUserName: "华北管理员",
            picName: "",
            picUrl: "",
            remark: "",
          };
          if (res.result.companyComplaintLogModelList.length <= 2) {
            res.result.companyComplaintLogModelList.push(obj);
            res.result.companyComplaintLogModelList.push(obj2);
          }
          console.log(res.result);
          this.Datadetail = res.result;
          if (res.result.complaintStatus == "09") {
            this.flag = true;
          } else {
            this.flags = true;
          }
        } else {
          this.$toast({
            type: "fail",
            message: res.returnMessage,
            duration: 1500,
          });

        }
      });
    },
    Typelist(val) {
      let obj = {
        "01": "产品质量投诉",
        "02": "产品计量投诉",
        "03": "运输批次投诉",
        "04": "包装破损投诉",
        "05": "退货申请",
        "06": "其他投诉",
      };
      return obj[val];
    },
    Typetsyj(val) {
      if (this.Datadetail.companyComplaintLogModelList.length > 2) {
        return this.Datadetail.companyComplaintLogModelList.filter((res) => {
          return res.category == val;
        });
      } else if (
        this.Datadetail.companyComplaintLogModelList.length == 2 &&
        val != "06"
      ) {
        return this.Datadetail.companyComplaintLogModelList.filter((res) => {
          return (
            res.category == val || res.category == "04" || res.category == "03"
          );
        });
      } else {
        let arr = [
          {
            category: "06",
            companyComplaintId: 366,
            companyComplaintLogId: 415,
            createTime: 1610007319000,
            createUserId: 95,
            createUserName: "华北管理员",
            picName: "",
            picUrl: "",
            remark: "",
          },
        ];
        return arr;
      }
    },
    goback() {
      // this.$router.push("/frontmenu/customer-service/customer-complaints");
    },
    // 上传买房结案文件
    otherFileUploadData(val) {
      // console.log(val)
      this.buyersetName = val.result.fileName;
      this.buyersetUrl = val.result.fileFullName; //fileFullName
    },
    removeOtherFileUpload(val) {
      console.log(val)
      this.form.salesFileName = "";
    },
  },
};
</script>
<style lang="stylus" scoped>
.complain-container {
  display: flex;
  flex-direction: column;
  height: 100%;
}

.main-containe {
  flex: 1;
  height: 85vh;
  position: absolute;
  padding: 0 20px;
  top: 0.88rem;
  left: 0;
  right: 0;
  // bottom: 0.88rem;
  font-size: 28px;
  overflow: auto;
}

.red {
  color: #ee0a24;
  font-size: 0.14rem;
}

.complain-container >>> .van-cell-group {
  background-color: #f6f4f5;
}

.complain-container >>> .van-field__label {
  width: 180px;
  font-size: 26px;
}

.complain-dropdown-menu >>> .van-cell {
  line-height: 50px;
}

.complain-container >>> .van-cell--required::before {
  left: 20px;
}

.complain-container >>> .van-popup {
  max-width: 95%;
}

.complain-dropdown-menu >>> .van-dropdown-menu__title {
  line-height: 50px;
}

.complain-dropdown-menu >>> .van-dropdown-menu__bar {
  border: 1px solid #666;
  background: #F4F4F4;
  border-radius: 10px;
}

.complain-dropdown-menu >>> .van-dropdown-menu__title::after {
  border: 10px solid;
  border-color: transparent transparent #dcdee0 #dcdee0;
  right: -20px;
  margin-top: -14px;
}

.complain-container .order-code >>> .van-cell.van-cell--clickable {
  padding: 0 30px 0 0;
  line-height: 50px;
  margin-top: 10px;
}

.complain-container .order-code >>> .van-cell__title.van-field__label {
  padding-left: 28px;
}

.complain-container .order-code >>> .van-cell__title {
}

.complain-container .order-code >>> .van-cell.van-field {
  padding: 20px 0 20px 0;
}

.complain-container .van-cell-group >>> .van-cell {
  line-height: 50px;
  padding: 20px 30px;
  margin-top: 10px;
}

.complain-container .order-code >>> .van-cell__right-icon {
  margin-left: 0.04rem;
  color: #969799;
  line-height: 50px;
  font-size: 30px;
  vertical-align: middle;
}

.complain-container {
  .title {
    font-size: 30px;
    height: 50px;
    line-height: 50px;
    padding: 20px 30px;
  }

  .file {
    min-height: 200px;
    background: #fff;
    padding: 20px 30px;
  }

  .complain-dropdown-menu {
    background: #fff;
    line-height: 50px;
    // padding: 20px 30px;
    margin-top: 10px;

    label {
      display: inline-block;
      width: 180px;
      font-size: 26px;
      padding-left: 20px;
    }

    .van-dropdown-menu {
      display: inline-block;
      padding: 20px 30px 20px 0;
      line-height: 50px;
      vertical-align: middle;
      width: calc(100% - 250px);
    }
  }
}

.btn-order {
  position: absolute;
  bottom: 2px;
  width: 100%;
  background: #fff;

  span {
    text-align: center;
    display: inline-block;
    width: 35%;
  }

  .card-btn {
    text-align: center;
    height: 100px;
    line-height: 100px;

    .btn {
      width: 90%;
      height: 80px;
      text-align: center;
      background: linear-gradient(132deg, #EF9623 0%, #E12020 100%);
      color: #ffffff;
      font-size: 32px;
      border-radius: 40px;
    }
  }
}
</style>